import { useEffect, useState } from 'react';
import axios from 'axios';
import { FetchMasterVirtualAccountsResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchMasterVirtualAccounts() {
  const [loading, setLoading] = useState(false);
  const [source] = useState(() => axios.CancelToken.source());

  useEffect(() => {
    return () => source.cancel();
  }, [source]);

  const fetchMasterVirtualAccounts = async (): Promise<FetchMasterVirtualAccountsResponse> => {
    setLoading(true);
    try {
      const res = await api.fetchMasterVirtualAccounts(source);
      return res;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchMasterVirtualAccounts,
  };
}
